export default __webpack_public_path__ + "static/media/c_4.080b8a83.jpg";